import Button from "../../../components/Buttons/Button";
import { Form } from "./style";
import { useForm } from "react-hook-form";
import { secondary } from "../../../theme";
import { useApi } from "../../../hooks/api";
import { useNavigate } from "react-router-dom";
import { useGlobal } from "../../../hooks/global";
import { FormEvent, useCallback, useMemo, useRef, useState } from "react";
import { ModalLoading } from "../../../components/Loadings/ModalLoading";
import { IGroupProps, userProps } from "../../../interfaces";
import { GenericForm, IGenericFormRefProps } from "../../../components/GenericForm";
import { validateEmail, validatePhone } from "../../../utils/validatesFields";
import { positionTypeOptions } from "../../../utils/options";

interface ICompanyDataFormProps {
    defaultData?: userProps | null;
}

export const ProfileForm: React.FC<ICompanyDataFormProps> = (props) => {
    const { defaultData } = props

    const navigate = useNavigate()
    const { notify, theme, isActiveActions, business } = useGlobal()
    const { api } = useApi()

    const activeActions = useMemo(() => isActiveActions(business?.subscriptions?.situation), [isActiveActions, business?.subscriptions?.situation]);

    const [loadingSave, setLoadingSave] = useState(false)

    const defaultValues = defaultData as any

    const { register, handleSubmit, control, watch, formState: { errors }, setError, setValue, trigger } = useForm({ defaultValues, mode: "all" });

    const _form = watch()

    const form_ref = useRef<IGenericFormRefProps>(null)

    const onSubmit = useCallback(async () => {
        setLoadingSave(true)

        try {
            const form = form_ref.current?.getForm()

            const data = { ...(form?.responsible_data ?? {}) };

            await api.put(`/users/${defaultData?.id}`, data);

            notify("Dados de perfil atualizados com sucesso.", "success")

            if (activeActions) navigate("/")
            else navigate("/dashboard")
        } catch (err: any) {
            const error = err.response ? err.response.data : "SERVER ERROR"
            if (error.path) setError(error.path, { type: "manual", message: error.message })
            else notify("ERRO INTERNO DO SISTEMA", "error")
        }

        setLoadingSave(false)
    }, [api, form_ref])

    const handleStopPropagation = useCallback((e: FormEvent<HTMLFormElement>) => {
        e?.stopPropagation()
        handleSubmit(onSubmit)(e)
    }, [handleSubmit, onSubmit, form_ref, _form, api])

    const groups: IGroupProps[] = [
        {
            name: "responsible_data",
            label: "Dados de Registro",
            fields: [
                [
                    {
                        name: "surname",
                        label: "Nome completo",
                        type: "input",
                        required: true
                    },
                    {
                        name: "position",
                        label: "Cargo",
                        type: "select-fixed",
                        options: positionTypeOptions,
                        required: true
                    },
                    {
                        name: "email",
                        label: "E-mail",
                        validate: validateEmail,
                        type: "input",
                        required: true
                    },
                    {
                        name: "phone",
                        label: "Telefone",
                        mask: "phone",
                        validate: validatePhone,
                        type: "input",
                        required: false
                    }
                ],
            ]
        },
    ]

    return (
        <>
            <Form onSubmit={handleStopPropagation} theme={theme}>
                <GenericForm
                    ref={form_ref}
                    groups={groups}
                    _form={_form}
                    control={control}
                    trigger={trigger}
                    errors={errors}
                    setValue={setValue}
                    register={register}
                />

                <Button
                    type="submit"
                    background={secondary[theme]}
                    color={"#FFF"}
                    style={{ padding: 8, fontSize: 14 }}
                    children={"Salvar"}
                />

            </Form>

            <ModalLoading
                loading={loadingSave}
                theme={theme}
            />

        </>

    )
}